import { Link } from 'react-router-dom';
import { hotGossipArticles, trendingTopics } from '@/mocks/home';

export default function HotGossipSection() {
  return (
    <section className="py-14 md:py-18 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            HOT
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门<span className="text-primary-500">爆料</span>
          </h2>
          <p className="text-sm text-foreground-500 mt-2">最新最热的网红塌房事件追踪</p>
        </div>

        {/* Gossip grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mb-12">
          {hotGossipArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="bg-background-100 rounded-xl overflow-hidden group cursor-pointer"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  title={`${article.title} - 吃瓜网站热门爆料`}
                />
                {article.tag && (
                  <span className={`absolute top-3 left-3 px-2 py-0.5 rounded-md text-[10px] font-bold text-background-50 ${
                    article.tag === '爆' ? 'bg-primary-500' : article.tag === '热' ? 'bg-accent-500' : 'bg-secondary-500'
                  }`}>
                    {article.tag}
                  </span>
                )}
              </div>
              <div className="p-4">
                <span className="text-[11px] text-primary-500 font-medium mb-1.5 block">
                  {article.category}
                </span>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
              </div>
            </Link>
          ))}
        </div>

        {/* Trending topics sidebar-style */}
        <div className="bg-background-100 rounded-2xl p-6 md:p-8">
          <div className="flex items-center gap-2 mb-5">
            <i className="ri-fire-line text-primary-500 text-lg" />
            <h3 className="font-heading text-lg font-bold text-foreground-950">热门话题</h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
            {trendingTopics.map((topic, idx) => (
              <Link
                key={topic.id}
                to={`/article/${topic.id}`}
                className="flex items-center gap-3 px-4 py-3 bg-background-50 rounded-lg hover:bg-primary-50 transition-colors group cursor-pointer"
              >
                <span className={`w-6 h-6 flex items-center justify-center rounded-md text-xs font-bold shrink-0 ${
                  idx < 3 ? 'bg-primary-500 text-background-50' : 'bg-secondary-200 text-secondary-700'
                }`}>
                  {idx + 1}
                </span>
                <div className="min-w-0">
                  <p className="text-sm text-foreground-800 truncate group-hover:text-primary-500 transition-colors">
                    {topic.title}
                  </p>
                  <p className="text-[11px] text-foreground-400">{topic.count}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}